var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.581 17.3888C25.7109 24.8897 18.1138 29.4546 10.612 27.5841C3.11335 25.714 -1.45158 18.1164 0.419371 10.616C2.28857 3.11428 9.88569 -1.45108 17.3852 0.418993C24.8865 2.28907 29.451 9.8875 27.581 17.3888Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1725 12.0065C20.4513 10.1434 19.0327 9.14187 17.0931 8.47374L17.7223 5.94997L16.1861 5.56712L15.5735 8.02438C15.1696 7.92374 14.7548 7.82879 14.3427 7.73472L14.9596 5.26127L13.4243 4.87842L12.7946 7.40131C12.4604 7.32518 12.1322 7.24992 11.8137 7.17072L11.8154 7.16285L9.69681 6.63386L9.28814 8.27466C9.28814 8.27466 10.4279 8.53587 10.4039 8.55206C11.0261 8.70739 11.1385 9.11912 11.1197 9.44553L10.403 12.3206C10.4459 12.3316 10.5015 12.3473 10.5627 12.3718C10.5115 12.3592 10.4568 12.3452 10.4004 12.3316L9.39577 16.3592C9.31964 16.5482 9.12668 16.8318 8.69176 16.7241C8.70708 16.7464 7.57514 16.4454 7.57514 16.4454L6.8125 18.2039L8.81165 18.7023C9.18357 18.7955 9.54804 18.893 9.90683 18.9849L9.27107 21.5376L10.8055 21.9204L11.4352 19.3949C11.8543 19.5087 12.2613 19.6137 12.6594 19.7126L12.032 22.2263L13.5682 22.6091L14.204 20.0613C16.8236 20.557 18.7934 20.3571 19.6226 17.9878C20.2907 16.08 19.5893 14.9796 18.211 14.262C19.2148 14.0306 19.9708 13.3703 20.1725 12.0065ZM16.6625 16.9285C16.1878 18.8362 12.9758 17.8049 11.9344 17.5463L12.778 14.1645C13.8194 14.4244 17.1587 14.9389 16.6625 16.9285ZM17.1377 11.9789C16.7046 13.7142 14.0311 12.8326 13.1639 12.6164L13.9288 9.54923C14.796 9.76538 17.5888 10.1688 17.1377 11.9789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyBtc);
export default __webpack_public_path__ + "static/media/Currency=BTC.2afc89474236ad6ec12cfb1cb0c0d5af.svg";
export { ForwardRef as ReactComponent };